import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InventoryList from './InventoryList';
import { fetchInventories, DeleteInventories } from '../../../ReduxSlices/Inventories/inventorySlice';
import LoadingDots from '../../shared/LoadingDots';

const InventorySection = ({ navigateTo }) => {
  const dispatch = useDispatch();
  const { inventories, loading } = useSelector((state) => state.inventories);
  const [showExportMenu, setShowExportMenu] = useState(false);

  //Fetch inventories only if store is empty
  useEffect(() => {
    if (inventories.length === 0 && !loading) {
      dispatch(fetchInventories());
    }
  }, [dispatch, inventories.length, loading]);

const handleDelete = (id, name, code, batchNumber) => {
  if (
    window.confirm(
      `Delete ${name} (${code} - ${batchNumber})? This action cannot be undone.`
    )
  ) {
    dispatch(DeleteInventories(id));
  }
};

  const handleEdit = (item) => {
    navigateTo('add_med', { editingItem: item });
  };

  //  Export handlers
  const handleExportExcel = () => {
    window.open('/api/v1/inventories/export_excel.xlsx', '_blank');
    setShowExportMenu(false);
  };

  const handleExportPDF = () => {
    window.open('/api/v1/inventories/export_pdf', '_blank');
    setShowExportMenu(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-around mt-2 w-[20%] ">
        <div className="flex flex-col text-[12px] text-gray-600 mt-2">
          <span className="mr-4">⛔ Expired</span>
          <span className="mr-4">⚠️ Low Stock</span>
        </div>

        {/* Export Dropdown */}
        <div className="relative inline-block text-left">
          <button
            onClick={() => setShowExportMenu((prev) => !prev)}
            type='button'
            className="primary"
          >
            Export
          </button>

          {showExportMenu && (
          <div className="absolute mt-1 w-40 bg-white border border-gray-200 rounded shadow-lg z-10">
            <button
              onClick={handleExportExcel}
              type='button'
              className="block  w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
            >
              📊 Excel
            </button>
            <button
              onClick={handleExportPDF}
              type='button'
              className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
            >
              📄 PDF
            </button>
          </div>
          )}
        </div>
      </div>
      {loading ? (
        <LoadingDots height={10} width={30} color="#38AD3E" />
      ) : (
        <InventoryList inventories={inventories} onEdit={handleEdit} onDelete={handleDelete} />
      )}
    </div>
  );
};

export default InventorySection;
